export const trackEvent = (eventName: string, params = {}) => {
  // @ts-ignore
  if (!window?.gtag) return;
  const brand = process.env.VUE_APP_BUILD_ENV.includes('sunpay') ? 'Sun Pay' : 'Klickl Pay';
  // @ts-ignore
  window?.gtag('event', eventName, {
    brand: brand,
    ...params
  });
  // @ts-ignore
  window?.gtag('set', 'user_properties', {
    plan_type: 'premium'
  });
}
